/* eslint-disable no-undef */
import * as Sentry from '@sentry/browser';
import { config } from '../../config';
import { trace } from './trace';

// version and environment are defined in the webpack.define plugin
const getSafeVersion = () => {
    try {
        return SERVICE_VERSION;
    } catch (e) {
        return 'Test';
    }
};

const getSafeEnvironment = () => {
    try {
        return SERVICE_ENVIRONMENT;
    } catch (e) {
        return 'Test';
    }
};

const release = getSafeVersion();
const environment = getSafeEnvironment();

// should have been called before using it here
// ideally before even rendering your react app
if ('development' !== environment) {
    trace(`initialize sentry with release version ${release}`);
    Sentry.init({
        dsn: config.sentryToken,
        environment,
        release,
    });
}

export const reportErrorToSentry = (...args) => {
    if ('development' !== environment) {
        Sentry.captureException(...args);
    }
};
